export enum StorageSortOrder {
    DESCENDANT = "desc",
    ASCENDANT = "asc"
}
